import { useFormik } from 'formik';
import { VFC } from 'react';
import { Col, Container, Row } from 'react-grid-system';
import * as Yup from 'yup';
import { useReturnContext } from '../../../contexts/returnContext';
import { tCarrierItem } from '../../../contexts/zod';
import { EASYCOM_ROUTES } from '../../../navigation';
import Divider from '../../atoms/Divider';
import Spacing from '../../atoms/Spacing';
import Typography from '../../atoms/Typography';
import PrimaryButton from '../../molecules/PrimaryButton';

import { useTranslation } from '../../../contexts/translationContext';

import TextInput from '../../molecules/TextInput';
import { useAppNavigate } from '../../../hooks/useAppNavigate';

const FreigtSelectionForm: VFC<tCarrierItem> = (props) => {
  const navigate = useAppNavigate();
  const { setSelectedCarrier } = useReturnContext();
  const { translate } = useTranslation();
  const { returns } = useReturnContext();

  const sumOfProducts = Object.keys(returns).reduce(
    (previousValue, currentValue) =>
      previousValue + returns[currentValue].returnData.amount,
    0,
  );

  const validationSchema = Yup.object().shape({
    numberOfParcels: Yup.number()
      .min(1, translate('freight_selection_min_error', null))
      .max(sumOfProducts, translate('freight_selection_max_error', { sumProducts: sumOfProducts }))
      .required(translate('is_required', null)),
  });

  const initialValues = {
    numberOfParcels: 1,
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      setSelectedCarrier({
        ...props,
        numberOfParcels: values.numberOfParcels,
      });
      navigate(EASYCOM_ROUTES.RETURNS_SUMMARY);
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <Container>
        <Spacing spacing={3} />
        <Row align="center">
          <Typography translateKey="choose_no_parcels" variant="h5" />
          <Spacing horizontal />
          <Divider />
        </Row>
        <Spacing spacing={3} />
        <Row>
          <Col xs={12} sm={12} md={12} lg={4}>
            <Row>
              <TextInput
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  formik.setFieldValue('numberOfParcels', e.target.value)
                }
                value={formik.values.numberOfParcels}
                placeholder="select_quantity"
                name="numberOfParcels"
                title="select_quantity"
                type="number"
                error={
                  formik.touched.numberOfParcels &&
                  formik.errors.numberOfParcels
                }
              />
            </Row>
            <Spacing spacing={3} />
            <Row>
              <PrimaryButton
                translateKey="summarize_returns"
                icon="arrow-right"
                type="submit"
              />
            </Row>
          </Col>
        </Row>
      </Container>
    </form>
  );
};

export default FreigtSelectionForm;

/* <Row>
        <Col>

            <Spacing spacing={4} />

            <Spacing spacing={3} />

            <Spacing spacing={3} />

        </Col> */
